import type { ReactNode } from "react";
import { VARIANT } from "../../lib/tokens";
import { useVariant } from "../../hooks/useVariant";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { Footer } from "./Footer";

export function AppShell({
  children,
  currentNavId = "home",
  loggedIn = false,
}: {
  children: ReactNode;
  currentNavId?: string;
  loggedIn?: boolean;
}) {
  const { variant } = useVariant();
  const v = VARIANT[variant];

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        background: v.bg,
        color: v.text,
      }}
    >
      <Sidebar variant={variant} loggedIn={loggedIn} currentId={currentNavId} />
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
        }}
      >
        <TopBar variant={variant} loggedIn={loggedIn} />
        <main style={{ flex: 1, minHeight: 0 }}>{children}</main>
        <Footer />
      </div>
    </div>
  );
}
